import { FC } from 'react';

import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';

interface Props {
   value: string;
   badge?: string;
   condition?: string;
   inheritSize?: boolean;
}

export const PhysicalProperty: FC<Props> = ({ value, badge, condition, inheritSize }) => (
   <Box gap="2xs" items="center">
      <Typography component="span" variant={inheritSize ? 'inherit' : 'body'}>
         {value}
      </Typography>
      {condition && (
         <Typography color="weak" component="i" variant={inheritSize ? 'inherit' : 'body'}>
            ({condition})
         </Typography>
      )}
      {badge && <Badge variant="disabled">{badge}</Badge>}
   </Box>
);
